export function IconNotApplicable() {
  return (
    <svg
      width="70"
      height="70"
      viewBox="0 0 70 70"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <circle cx="35" cy="35" r="33.5" stroke="" strokeWidth="3" />
      <path
        d="M50 33C51.1046 33 52 33.8954 52 35C52 36.1046 51.1046 37 50 37H20C18.8954 37 18 36.1046 18 35C18 33.8954 18.8954 33 20 33H50Z"
        fill="black"
      />
    </svg>
  );
}
